var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55335 5.61013L8.99023 0.173248C9.22123 -0.0577492 9.59575 -0.0577496 9.82675 0.173248C10.0577 0.404246 10.0577 0.778766 9.82675 1.00976L3.98991 6.8466C3.98411 6.85293 3.97813 6.85917 3.972 6.8653C3.86812 6.96918 3.73522 7.02634 3.5994 7.03679C3.43292 7.04985 3.26197 6.9927 3.13463 6.86537C3.12799 6.85873 3.12154 6.85196 3.11528 6.84509L0.173248 3.90306C-0.0577497 3.67207 -0.057749 3.29755 0.173248 3.06655C0.404246 2.83555 0.778766 2.83555 1.00976 3.06655L3.55335 5.61013Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.3df5cff9711c735635069e3ff3f35056.svg";
export { ForwardRef as ReactComponent };